import { DomainObject } from '../../../models';

export function useSubTitle<OBJECT extends DomainObject>(
  callback: (data: OBJECT | null) => string
) {
  return function useSubTitleIntern(data: OBJECT | null) {
    return callback(data);
  };
}
